import styled from "styled-components";

import { info } from "./Container.info";

export const Root = styled.div`
  --container-padding: ${props => props.theme.spacing.spacing_24};
  --container-max-inner-width: 0px;
  --container-max-outer-width: calc(
    var(--container-max-inner-width) + var(--container-padding) * 2
  );

  width: 100%;
  margin-left: auto;
  margin-right: auto;
  padding-left: var(--container-padding);
  padding-right: var(--container-padding);

  ${props => props.theme.breakpointsV2.largeMobile} {
    --container-max-inner-width: ${info.maxInnerWidth.largeMobile}px;

    max-width: var(--container-max-outer-width);
  }

  ${props => props.theme.breakpointsV2.smallTablet} {
    --container-padding: ${props => props.theme.spacing.spacing_48};

    max-width: none;
  }

  ${props => props.theme.breakpointsV2.tablet} {
    --container-max-inner-width: ${info.maxInnerWidth.tablet}px;

    max-width: var(--container-max-outer-width);
  }

  ${props => props.theme.breakpointsV2.smallDesktop} {
    --container-padding: ${props => props.theme.spacing.spacing_64};

    max-width: none;
  }

  ${props => props.theme.breakpointsV2.desktop} {
    --container-max-inner-width: ${info.maxInnerWidth.desktop}px;

    max-width: var(--container-max-outer-width);
  }

  ${props => props.theme.breakpointsV2.largeDesktop} {
    --container-max-inner-width: ${info.maxInnerWidth.largeDesktop}px;
  }
`;
